import React, { FC } from 'react';
import { LineItemType } from '.';
import LineItem from './LineItem';

type ListProps = {
    data: LineItemType[];
    currency: string;
    onPress?: (lineItem: LineItemType, index: number) => void;
};

const LineItemsView: FC<ListProps> = ({ data, ...props }) => {
    return (
        data?.map((lineItem: LineItemType, index: number) => (
            <LineItem
                data={lineItem}
                key={index}
                {...props}
            />
        ))
    );
};

export default LineItemsView;
